<template>
  <div>
    <h2 class="content-block-title">{{ title }}</h2>

    <dx-data-grid
      v-if="!loading"
      class="dx-card content-block"
      :data-source="dataSource"
      key-expr="path"
      :focused-row-index="0"
      :show-borders="false"
      :focused-row-enabled="true"
      :column-auto-width="true"
      :column-hiding-enabled="true"
    >
      <dx-paging :page-size="20" />
      <dx-pager :show-page-size-selector="true" :show-info="true" :allowed-page-sizes="[5, 10, 20, 30, 50]" />
      <dx-filter-row :visible="true" />

      <dx-column data-field="common_name" caption="Common Name" />
      <dx-column
        data-field="subject_alternative_names"
        caption="SANs"
        cell-template="sanCell"
      />
      <dx-column data-field="expired" caption="Expired" cell-template="expiredCell" />
      <dx-column data-field="expiring_soon" caption="Expiring Soon" cell-template="expiringSoonCell" />
      <!-- <dx-column data-field="parsing_error" caption="Parsing Error" cell-template="parsingErrorCell" /> -->
      <!-- Days Remaining -->
      <dx-column data-field="days_remaining" caption="Days" />   
      <!-- format="yyyy-MM-dd HH:mm:ss" -->
      <dx-column data-field="not_before" caption="Valid From" data-type="date" format="yyyy-MM-dd" />
      <dx-column data-field="not_after" caption="Valid Until" data-type="date" format="yyyy-MM-dd" />
      <dx-column data-field="path" caption="File Path" />
      <dx-column data-field="issuer" caption="Issuer" />

      <template #expiredCell="{ data }">
        <span :class="['tag-pill', data.value ? 'tag-expired' : 'tag-ok']">
          {{ data.value ? 'Yes' : 'No' }}
        </span>
      </template>

      <template #expiringSoonCell="{ data }">
        <span :class="['tag-pill', data.value ? 'tag-warning' : 'tag-ok']">
          {{ data.value ? 'Yes' : 'No' }}
        </span>
      </template>

      <template #parsingErrorCell="{ data }">
        <span v-if="data.value" class="tag-pill tag-error">
          {{ data.value }}
        </span>
        <span v-else class="tag-pill tag-ok">OK</span>
      </template>

        <template #sanCell="{ data }">
        <span v-if="Array.isArray(data.value)">
            {{ data.value.join(', ') }}
        </span>
        <span v-else>
            -
        </span>
        </template>


    </dx-data-grid>

    <div v-if="loading" class="loading-overlay">
      <DxLoadIndicator :height="60" :width="60" />
    </div>
  </div>
</template>

<script>
  import {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow
  } from 'devextreme-vue/data-grid';

  import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
  import axios from 'axios';


  export default {
    name: 'CertificatesGrid',
    components: {
      DxDataGrid,
      DxColumn,
      DxPaging,
      DxPager,
      DxFilterRow,
      DxLoadIndicator
    },
    data() {
      return {
        title: 'HAProxy SSL Certificates',
        loading: true,
        dataSource: []
      };
    },
    mounted() {
      this.loadCertificates();
    },
    methods: {
      async loadCertificates() {
        try {
          // const res = await fetch('/internal/haproxy/certs');
          const response = await axios.get('/api/internal/haproxy/certs');
          // const json = await res.json();
          // this.dataSource = json;
          this.dataSource = Array.isArray(response.data) ? response.data : [];
        } catch (err) {
          console.error('Error loading data:', err);
        } finally {
          this.loading = false;
        }
      }
    }
  };
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
}

.tag-pill {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: white;
}

.tag-ok {
  background-color: #4caf50;
}

.tag-warning {
  background-color: #ff9800;
}

.tag-expired {
  background-color: #f44336;
}

.tag-error {
  background-color: #d32f2f;
  max-width: 250px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
